/**
 * Решение при lives <= 0: второй шанс или fail.
 */
export type SecondChanceGateDecision = 'request_minigame' | 'fail';

export function decideSecondChanceGate(input: {
  lives: number;
  secondChanceUsed: boolean;
  alreadyRequested: boolean;
  alreadyFailed: boolean;
}): SecondChanceGateDecision | null {
  if (input.lives > 0 || input.alreadyFailed || input.alreadyRequested) {
    return null;
  }
  if (!input.secondChanceUsed) {
    return 'request_minigame';
  }
  return 'fail';
}
